import React, {ReactNode} from 'react';

import {defaultConfig} from '../config';
import {ErrorBoundary} from './ErrorBoundary';
import {useErrorHandler} from './useErrorHandler';

interface ErrorHandlerProps {
  readonly children: ReactNode;
  readonly section?: string;
  readonly layer?: string;
  readonly onError?: (error: unknown) => void;
}

const ErrorHandler = ({
  children,
  layer = defaultConfig.layer,
  onError,
  section = defaultConfig.section,
}: ErrorHandlerProps): React.ReactElement => {
  const logger = useErrorHandler();

  return (
    <ErrorBoundary captureException={logger.captureException} layer={layer} onError={onError} section={section}>
      {children}
    </ErrorBoundary>
  );
};

export {ErrorHandler};
